import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { AuthShell } from "@/components/account/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      <p className="text-muted-foreground mt-6">
        Sign in to manage customers, donations, and orders.
      </p>

      <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email">Email address</Label>
          <Input
            id="email" type="email" required value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@beckministries.org"
            data-testid="login-email-input"
            className="h-11"
          />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" className="text-xs text-primary hover:underline" data-testid="forgot-password-link">
              Forgot password?
            </Link>
          </div>
          <Input
            id="password" type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
            data-testid="login-password-input"
            className="h-11"
          />
        </div>
        {error && (
          <p className="text-sm text-destructive" data-testid="login-error">{error}</p>
        )}
        <Button type="submit" disabled={busy} className="w-full h-11 text-base" data-testid="login-submit-button">
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>

      <p className="text-xs text-muted-foreground mt-8">
        Accounts are created by invitation only. If you need access, please ask your administrator.
      </p>
    </AuthShell>
  );
}
